import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    InitContractEndStatus: 'idle',
    InitContractEndError: undefined as any,
    SetContractKndEndStatus: 'idle',
    SetContractKndEndError: undefined as any,
    SetContractOptEndStatus: 'idle',
    SetContractOptEndError: undefined as any,

    flbelEndList: [] as any[],
    defaultValues: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const InitContractEnd = createAsyncThunk('flbelEndSlice/InitContractEnd', async ({ parentModel }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ContractMenu_InitContractEnd/?flbelid=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { InitContractEndStatus } = getState().flbelEndSlice
        return InitContractEndStatus !== 'pending'
    }
})

export const SetContractKndEnd = createAsyncThunk('flbelEndSlice/SetContractKndEnd', async ({ parentModel, flbelEnd }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/ContractMenu_SetContractEnd/`,
        prepareData({
            FlbelId: parentModel.HDR_ID,
            ContractendDate: flbelEnd.ContractEnd,
            CancelDate: flbelEnd.GekuendigtAm,
            ReturnDate: flbelEnd.Rueckgabedatum,
            MoveoutDate: flbelEnd.Auszugsdatum,
            FlvtgId: flbelEnd.BrCdFlvtgId,
            FlvtgAnswerDate: '',
            MieterAntwortTyp: null,
            ContractendType: flbelEnd.VertragsendeTyp,
            ContractendReason: flbelEnd.Kuendigungsgrund,
            EinzugEntziehen: flbelEnd.LastschriftEntziehen,
            DeleteVMRecht: true,
            AnteilSollbetrag: flbelEnd.AnteilSollVariante
        }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { SetContractKndEndStatus } = getState().flbelEndSlice
        return SetContractKndEndStatus !== 'pending'
    }
})

export const SetContractOptEnd = createAsyncThunk('flbelEndSlice/SetContractOptEnd', async ({ parentModel, flbelEnd }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/ContractMenu_SetContractEnd/`,
        prepareData({
            FlbelId: parentModel.HDR_ID,
            ContractendDate: flbelEnd.OptionContractEnd,
            CancelDate: flbelEnd.GekuendigtAm,
            ReturnDate: flbelEnd.Rueckgabedatum,
            MoveoutDate: flbelEnd.Auszugsdatum,
            FlvtgId: flbelEnd.OptFlvtgId,
            FlvtgAnswerDate: flbelEnd.OptionAntwortAm,
            MieterAntwortTyp: flbelEnd.OptionAntwortMieter,
            ContractendType: flbelEnd.VertragsendeTyp,
            ContractendReason: flbelEnd.Kuendigungsgrund,
            EinzugEntziehen: flbelEnd.LastschriftEntziehen,
            DeleteVMRecht: true,
            AnteilSollbetrag: flbelEnd.AnteilSollVariante
        }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { SetContractOptEndStatus } = getState().flbelEndSlice
        return SetContractOptEndStatus !== 'pending'
    }
})

const FlbelEndSlice = createSlice({
    name: 'flbelEndSlice',
    initialState,
    reducers: {
        resetInitContractEnd: (state) => {
            state.defaultValues = undefined
            state.InitContractEndError = undefined
        },
        resetInitContractEndError: (state) => {
            state.InitContractEndError = undefined
        },
        resetSetContractKndEndError: (state) => {
            state.SetContractKndEndError = undefined
        },
        resetSetContractOptEndError: (state) => {
            state.SetContractOptEndError = undefined
        },
        removeFromFlbelEndListById: (state, action) => {
            state.flbelEndList = state.flbelEndList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlbelEndListByIds: (state, action) => {
            state.flbelEndList = state.flbelEndList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flbelEndList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.InitContractEndStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.flbelEndList = []
            state.InitContractEndStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(InitContractEnd.pending, (state) => {
            state.InitContractEndStatus = 'pending'
            state.InitContractEndError = undefined
        })
        builder.addCase(InitContractEnd.fulfilled, (state, action) => {
            state.InitContractEndStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultValues = newItem
            }
        })
        builder.addCase(InitContractEnd.rejected, (state, action) => {
            state.InitContractEndStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.InitContractEndError = action.error.message
            } else {
                state.InitContractEndError = action.payload
            }
        })

        builder.addCase(SetContractKndEnd.pending, (state) => {
            state.SetContractKndEndStatus = 'pending'
            state.SetContractKndEndError = undefined
        })
        builder.addCase(SetContractKndEnd.fulfilled, (state, action) => {
            state.SetContractKndEndStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flbelEndList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flbelEndList.push(newItem) }
                else { state.flbelEndList[i] = { ...state.flbelEndList[i], ...newItem } }
            }
        })
        builder.addCase(SetContractKndEnd.rejected, (state, action) => {
            state.SetContractKndEndStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.SetContractKndEndError = action.error.message
            } else {
                state.SetContractKndEndError = action.payload
            }
        })

        builder.addCase(SetContractOptEnd.pending, (state) => {
            state.SetContractOptEndStatus = 'pending'
            state.SetContractOptEndError = undefined
        })
        builder.addCase(SetContractOptEnd.fulfilled, (state, action) => {
            state.SetContractOptEndStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flbelEndList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flbelEndList.push(newItem) }
                else { state.flbelEndList[i] = { ...state.flbelEndList[i], ...newItem } }
            }
        })
        builder.addCase(SetContractOptEnd.rejected, (state, action) => {
            state.SetContractOptEndStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.SetContractOptEndError = action.error.message
            } else {
                state.SetContractOptEndError = action.payload
            }
        })

    }
})

export const {
    resetInitContractEnd,
    resetInitContractEndError,
    resetSetContractKndEndError,
    resetSetContractOptEndError,
    removeFromFlbelEndListById,
    removeFromFlbelEndListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlbelEndSlice.actions
export default FlbelEndSlice.reducer
